import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import { ICodeInfo } from './types/affiliate';
import { IBaseResponse } from './types/common';

export function getUserCodeInfo() {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/affiliate/apis/v1/bind_aff_user_info`;
    fetchData
      .post<IBaseResponse<ICodeInfo>>(url)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}
